import Enum from '/@/modules/core/app/helpers/Enum';
import { AdvisorProFreeWillsLimit } from '/@/modules/financialadvisor/constants/AdvisorProFreeWillsLimit';

export class FinancialAdvisorProUpsellFeature extends Enum {
  key!: string;
  titleKey!: string;
  descriptionKey!: string;
  icon!: string;
  descriptionParams?: Record<string, number>;

  static UNLIMITED_DIGITAL_VAULTS: FinancialAdvisorProUpsellFeature = {
    key: 'unlimited_digital_vaults',
    titleKey: 'financialadvisor.pro-upsell-feature-vaults-title',
    descriptionKey: 'financialadvisor.pro-upsell-feature-vaults-description',
    icon: 'cls-saving-safe'
  };

  static FREE_ONLINE_WILLS: FinancialAdvisorProUpsellFeature = {
    key: 'free_online_wills',
    titleKey: 'financialadvisor.pro-upsell-feature-wills-title',
    descriptionKey: 'financialadvisor.pro-upsell-feature-wills-description',
    descriptionParams: {
      freeYearlyWillsLimit: AdvisorProFreeWillsLimit.ANNUAL_PLAN_LIMIT,
      freeMonthlyWillsLimit: AdvisorProFreeWillsLimit.MONTHLY_PLAN_LIMIT
    },
    icon: 'cls-legal-certificate'
  };

  static SMART_OPPORTUNITY_ALERTS: FinancialAdvisorProUpsellFeature = {
    key: 'smart_opportunity_alerts',
    titleKey: 'financialadvisor.pro-upsell-feature-alerts-title',
    descriptionKey: 'financialadvisor.pro-upsell-feature-alerts-description',
    icon: 'cls-light-bulb-shine-opportunity'
  };

  static AI_DOCUMENT_EXTRACTOR: FinancialAdvisorProUpsellFeature = {
    key: 'ai_document_extractor',
    titleKey: 'financialadvisor.pro-upsell-feature-extractor-title',
    descriptionKey: 'financialadvisor.pro-upsell-feature-extractor-description',
    icon: 'cls-common-file-check-ai'
  };

  static INTELLIGENT_GENOGRAM: FinancialAdvisorProUpsellFeature = {
    key: 'intelligent_genogram',
    titleKey: 'financialadvisor.pro-upsell-feature-genogram-title',
    descriptionKey: 'financialadvisor.pro-upsell-feature-genogram-description',
    icon: 'cls-accounting-human-hierarchy'
  };

  static PREFILL_CLIENT_VAULTS: FinancialAdvisorProUpsellFeature = {
    key: 'prefill_client_vaults',
    titleKey: 'financialadvisor.pro-upsell-feature-prefill-title',
    descriptionKey: 'financialadvisor.pro-upsell-feature-prefill-description',
    icon: 'cls-content-paper-edit'
  };
}
